
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';

class ObjectUtils {
  static isRenderable(value) {
    if (value === true) {
      return true;
    }
    return !_isNil(value) && (!_isEmpty(value) || _isNumber(value));
  }
}

export default ObjectUtils;
